export default {"src":"/_next/static/media/Free-Shipping-Badge.9498fb98.svg","height":86,"width":79};